import { MOBILE_NETWORKS } from "../../constants/mobileNetworks";

export default function NetworkSelector({
  value = "",
  onChange,
  disabled = false,
  embed = false,
  labelClassName = "text-xs font-semibold tracking-wide uppercase text-slate-500",
  error = false,
}) {
  return (
    <fieldset className="min-w-0" disabled={disabled}>
      <legend className={`${labelClassName} mb-2 block`}>
        Mobile network <span className="text-red-500">*</span>
      </legend>
      <div
        className={`grid grid-cols-3 gap-2 ${embed ? "sm:gap-2" : "sm:gap-3"}`}
        role="radiogroup"
        aria-label="Select your mobile network"
      >
        {MOBILE_NETWORKS.map((network) => {
          const selected = value === network.value;
          return (
            <label
              key={network.value}
              className={[
                "group relative flex cursor-pointer flex-col items-center rounded-2xl border bg-white p-2 text-center transition sm:p-2.5",
                selected
                  ? "border-[#FFD221] bg-[#FFD221]/10 ring-2 ring-[#FFD221]/40"
                  : error
                    ? "border-amber-300 hover:border-amber-400"
                    : "border-slate-200 hover:border-slate-300 hover:bg-slate-50/80",
                disabled ? "cursor-not-allowed opacity-60" : "",
              ].join(" ")}
            >
              <input
                type="radio"
                name="network"
                value={network.value}
                checked={selected}
                onChange={() => onChange?.(network.value)}
                className="sr-only"
              />
              <span
                className={`flex h-12 w-12 items-center justify-center overflow-hidden rounded-xl bg-white sm:h-14 sm:w-14 ${
                  selected ? "ring-1 ring-[#FFD221]/50" : "ring-1 ring-slate-100"
                }`}
              >
                <img
                  src={network.logo}
                  alt=""
                  className="h-full w-full object-contain p-1"
                  loading="lazy"
                />
              </span>
              <span
                className={`mt-1.5 text-[10px] font-bold leading-tight sm:text-[11px] ${
                  selected ? "text-slate-900" : "text-slate-600"
                }`}
              >
                {network.shortLabel}
              </span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
